import { axiosApiInstance, headers } from './_httpHeaders';

// U009. 오류 처리 현황 게시판 리스트
export const getErrorHandlingList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/selectErrorHandlingList.do`,
    params: {
      CSvcEngine: reqParam.CSvcEngine,
      CDocType: reqParam.CDocType,
      dsrbtrKorNm: reqParam.dsrbtrKorNm,
      errPrcsYn: reqParam.errPrcsYn,
      checkDate: reqParam.checkDate,
      searchText: reqParam.searchText,
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
    },
  });

// U010. 오류 처리 현황 게시판 상세보기
export const getErrorHandlingDetailView = (errSeq) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/selectErrorHandlingDetailView.do`,
    params: {
      errSeq: errSeq,
    },
  });

// U011. 이용중인 (유통사) 서비스 리스트
export const getCompanyList = (usCode) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/selectCompanyList.do`,
    params: {
      usCode: usCode,
    },
  });

// U012. 시스템 등록
export const insertCustomIpInfo = (resultList) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/insertCustomIpInfo.do`,
    data: {
      resultList: resultList,
    },
  });

// U013. 시스템 수정(등록 , 수정, 삭제)
export const saveCustomSysInfo = (resultList) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/saveCustomSysInfo.do`,
    data: {
      resultList: resultList,
    },
  });

// U014. 시스템 상세 조회
export const getOsIpDetail = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/selectOsIpDetail.do`,
    params: {},
  });

// U045. 오류 처리 현황 문서 구분 리스트
export const getServiceNmList = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/selectServiceNmList.do`,
    params: {},
  });

// U046. 오류 처리 현황 시스템 구분 리스트
export const getDocNmList = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/selectDocNmList.do`,
    params: {},
  });

// U073. 오류 처리 현황 게시판 리스트 엑셀다운
export const excellErrorHandlingList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/systemmngt/excellErrorHandlingList.do`,
    params: {
      CSvcEngine: reqParam.CSvcEngine,
      CDocType: reqParam.CDocType,
      checkDate: reqParam.checkDate,
      searchText: reqParam.searchText,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
    },
  });
